export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  function formatDate(el) {
    const datesMonth = el.text().slice(0, 3);
    const datesDay = el.text().slice(4, 7).replace(",", "");
    el.html(`<span>${datesMonth}</span><span> ${datesDay.trim()}</span>`);
  }

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');
  setTimeout(function () {
    $(".all-events-btn").wrap("<div class='events-btn-wrap'></div>");
  }, 2000);
  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    // options
    , detectIpad: IPADDETECTED
    // options
    , allEventsLink: true
    , allEventsLinkText: 'See All Events'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: 'BUY NOW' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 5
    , isResponsive: false
    , hasDescription: false
    , textContainer: true
    , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
    , attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {
      // console.log(data);
      // use function below if "more" text needs to appear at end of description text

      $('#multiScheduleFeature .featureItem').each(function () {
        var itemDescripton = $(this).find('.featureItemDescription');

        //uncomment below if you need to slice the date string up into something shorter like "Oct 31"
        var eventDate = $(this).find($('span.featureItemDate'));
        const dateYear = eventDate.text().slice(-6);
        
        formatDate(eventDate);
        eventDate.append(`<span class='year'>${dateYear}</span>`);

        // // uncomment below if you need to limit the characters in the description text
        var characterLimit = 120;
        var itemDescriptonText = itemDescripton.text();
        if (itemDescriptonText.length > characterLimit) {
          var trimmedText = itemDescriptonText.substring(0, characterLimit) + '...';
          itemDescripton.text(trimmedText);
        }
        // uncomment below if 'more' link is needed after event description
        // itemDescripton.append("<span class='more-text'>More</span>");
      });
    }
  });

};

